export const MESSAGES = {
  CHARGING_SESSION: {
    BANNER_TITLE_FINISHED: 'Recarga Concluída',
    BANNER_TITLE_IN_PROGRESS: 'Sessão Ativa (Recuperada)',
    BANNER_BODY_FINISHED: 'Veja o resumo da sua última carga',
    BANNER_BODY_IN_PROGRESS: 'Carregando...',
    OFFLINE_RECONNECTING: 'Modo Offline - Reconectando',
    IN_IDLE: 'Sua sessão entrou em ociosidade!',
    IDLE_WARNING: 'Desconecte o veículo para evitar cobranças adicionais.',
    FINISHING_SESSION_TITLE: 'Carregamento concluído',
    FINISHING_SESSION_SUBTITLE: 'Retire o cabo para liberar o carregador.',
    BATTERY_LABEL: 'Bateria',
    BATTERY_UNKNOWN: 'Não informado',
    BATTERY_LEVEL_ARIA_LABEL: 'Nível da bateria',
    POWER_LABEL: 'Potência',
    ERROR_LOADING_SESSION: 'Erro ao carregar sessão ativa do storage',
    ERROR_UPDATING_STORAGE: 'Erro ao atualizar SecureStorage',
    ERROR_CLEARING_STORAGE: 'Erro ao limpar SecureStorage',
  },
} as const
